<script>
  import Quote from "./components/Quote.svelte";
  import Cart from "./components/Cart.svelte";
  import Bundle from "./components/Bundle.svelte";

  export let type;
  export let productTitle;
  export let cartItemKey = undefined;
  export let bundleId;
  export let isModalOpen = false;

  function handleModalClosing() {
    isModalOpen = false;

    document.body.classList.remove("modal-is-open");
  }
</script>

{#if isModalOpen}
  {#if type === "quote"}
    <Quote {productTitle} on:close={handleModalClosing} />
  {:else if type === "bundle"}
    <Bundle {productTitle} {bundleId} on:close={handleModalClosing} />
  {:else}
    <Cart {cartItemKey} on:close={handleModalClosing} />
  {/if}
{/if}

<style>
  :global(.modal-is-open) {
    overflow: hidden;
  }

  

  :global(.single_add_to_cart_button.is-loading::before) {
    display: none !important;
  }
</style>
